export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_98eccbc0-958d-40e1-9f07-b9e3c8974e72/artifacts/6wkl6p4q_logo%20sarah.jpg";
export const FLYER_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_98eccbc0-958d-40e1-9f07-b9e3c8974e72/artifacts/6hgamj1j_fiche.jpg";
export const HERO_IMG =
  "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwY2xlYW58ZW58MHx8fHwxNzg1MTk4MzA5fDA&ixlib=rb-4.1.0&q=85";
export const TRUST_IMG =
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80";
export const OFFICE_IMG =
  "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbGVhbiUyMG9mZmljZSUyMGRlc2t8ZW58MHx8fHwxNzg1MTk4MzEwfDA&ixlib=rb-4.1.0&q=85";
